import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=5fc7a41a&scoped=true"
import script from "./Logo.vue?vue&type=script&lang=ts"
export * from "./Logo.vue?vue&type=script&lang=ts"
import style0 from "./Logo.vue?vue&type=style&index=0&id=5fc7a41a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc7a41a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fc7a41a')) {
      api.createRecord('5fc7a41a', component.options)
    } else {
      api.reload('5fc7a41a', component.options)
    }
    module.hot.accept("./Logo.vue?vue&type=template&id=5fc7a41a&scoped=true", function () {
      api.rerender('5fc7a41a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout-editor/Logo.vue"
export default component.exports